var map = {
	"./ar.js": [
		"7598",
		"lang-ar-js"
	],
	"./en.js": [
		"80fd",
		"lang-en-js"
	],
	"./fr.js": [
		"a4e0",
		"lang-fr-js"
	],
	"./zh.js": [
		"6a91",
		"lang-zh-js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2d41";
module.exports = webpackAsyncContext;